import { translate } from "app/filters/i18nFilter";
import { colorsPalettes } from "@similarweb/styles";
import { StyledDefaultCellHeader } from "app/pages/segment-user-flow/buyer-journey/StyledComponents";

export const Interactions = {
    B1: {
        get interactionName() {
            return translate("buyer.journey.interactions.b1.name");
        },
        interactionId: "B1",
        interactionIndex: 1,
        maxPairs: 5,
        nodeColor: colorsPalettes.blue[200],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b1.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b1.to.column.display");
        },
    },
    B2: {
        get interactionName() {
            return translate("buyer.journey.interactions.b2.name");
        },
        interactionId: "B2",
        interactionIndex: 2,
        maxPairs: 6,
        nodeColor: colorsPalettes.blue[300],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b2.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b2.to.column.display");
        },
    },
    B3: {
        get interactionName() {
            return translate("buyer.journey.interactions.b3.name");
        },
        interactionId: "B3",
        interactionIndex: 3,
        maxPairs: 7,
        nodeColor: colorsPalettes.blue[400],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b3.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b3.to.column.display");
        },
        customTableHeaderColumnTo: StyledDefaultCellHeader,
    },
    B4: {
        get interactionName() {
            return translate("buyer.journey.interactions.b4.name");
        },
        interactionId: "B4",
        interactionIndex: 4,
        maxPairs: 4,
        nodeColor: colorsPalettes.midnight[500],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b4.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b4.to.column.display");
        },
        customTableHeaderColumnFrom: StyledDefaultCellHeader,
    },
    B5: {
        get interactionName() {
            return translate("buyer.journey.interactions.b5.name");
        },
        interactionId: "B5",
        interactionIndex: 5,
        maxPairs: 5,
        nodeColor: colorsPalettes.blue[400],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b5.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b5.to.column.display");
        },
    },
    B6: {
        get interactionName() {
            return translate("buyer.journey.interactions.b6.name");
        },
        interactionId: "B6",
        interactionIndex: 6,
        maxPairs: 4,
        nodeColor: colorsPalettes.blue[300],
        get fromColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b6.from.column.display");
        },
        get toColumnDisplayTitle() {
            return translate("buyer.journey.interactions.b6.to.column.display");
        },
    },
};
export const SEGMENT_MIN_VISITS_THRESHOLD = 500;
